import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import TransfersKindergarten from "src/components/panel/transfers/transfers_kindergarten/TransfersKindergarten";
import * as AppConfig from "../../../helpers/AppConfig";

const TransferKindergartenListView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("transfer_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("transfer_title")}
          subtitle={t("transfer_subtitle")}
        />

        {/* <Breadcrumb
            title={t("transfer_hr_title")}
            subtitle={t("transfer_hr_subtitle")}
          /> */}

        <TransfersKindergarten />
      </Sidebar>
    </>
  );
};

export default TransferKindergartenListView;
